// extracted by mini-css-extract-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_nML","cls2":"ProfilePdfPackCard-cls2_Lzs ProfilePdfPackCard-cls1_nML"};